module.exports = __webpack_public_path__ + "img/PRCA2_Mast.3bd82e0f.png";